import React from "react";

export default function HeaderText() {
  return (
    <div className="py-20 md:py-32 px-4 text-center">
      <h1
        className="animate__animated animate__fadeInUp text-white font-bold tracking-wide text-3xl md:text-4xl lg:text-5xl"
        style={{ textShadow: '0 2px 24px rgba(0,0,0,0.6)', letterSpacing: '0.04em' }}
      >
        Marmolería Colaiacovo
      </h1>
      <div style={{ width: '72px', height: '3px', background: '#ff7a00', margin: '20px auto 24px', borderRadius: '2px' }} />
      <h2
        className="animate__animated animate__fadeInUp text-white italic font-light text-lg md:text-xl lg:text-2xl"
        style={{ opacity: 0.92, textShadow: '0 1px 12px rgba(0,0,0,0.5)', letterSpacing: '0.12em' }}
      >
        El apellido del mármol
      </h2>
    </div>
  );
}
